import type { Resource } from '../../';
export const forms_field_phone: Resource = {"default":"Phone Number"};
